<template>
  <div class="mybalance">
    <!-- 资金情况 -->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <p class="ft16">资金情况</p>
      </div>
      <div class="text item mybalance_content flex flex-info">
        <div>
          <p class="ft16 D1D1D1 mb20">资金金额</p>
          <p class="ft28 D1D1D1">{{ getDealer.totalAmount }}</p>
        </div>
        <div>
          <p class="ft16 D1D1D1 mb20">占用金额（元）</p>
          <p class="ft28 D1D1D1">{{ getDealer.occupyAmount }}</p>
        </div>
         <div>
          <p class="ft16 D1D1D1 mb20">可用金额（元）</p>
          <p class="ft28 D1D1D1">{{ getDealer.usableAmount }}</p>
        </div>
        <!-- <div class="mt20">
          <p>
            <span class="ft14 C787878 inline_block w100">本月可用余额:</span>
            <span class="ft14 D1D1D1">{{
              getDealer.thisMonthUsableAmount
            }}</span>
          </p>
          <p class="mt8">
            <span class="ft14 C787878 inline_block w100">上月余额:</span>
            <span class="ft14 D1D1D1">{{ getDealer.lastMonthUsableAmount }}</span>
          </p>
        </div>
        <div class="mt20">
          <p>
            <span class="ft14 C787878 inline_block w100">本月上账金额:</span>
            <span class="ft14 D1D1D1">{{ getDealer.thisMonthAccountAmount }}</span>
          </p>
          <p class="mt8">
            <span class="ft14 C787878 inline_block w100">本月使用金额:</span>
            <span class="ft14 D1D1D1">{{ getDealer.thisMonthHasUseAmount }}</span>
          </p>
        </div> -->
      </div>
    </el-card>
    <!-- 折扣情况 -->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <p class="ft16">返利&现金垫付情况</p>
      </div>
      <div class="text item mybalance_content flex justify_content_between">
        <div>
          <p class="ft16 D1D1D1 mb20">本月期末可用余额</p>
          <p class="ft28 D1D1D1">{{ discountData.usableAmount }}</p>
        </div>
        <div class="mt20">
          <p>
            <span class="ft14 C787878 inline_block w120">本月期初剩余金额:</span>
            <span class="ft14 D1D1D1">{{
              discountData.thisMonthInitNotUseAmount
            }}</span>
          </p>
          <p class="mt8">
            <span class="ft14 C787878 inline_block w120">本月上账金额:</span>
            <span class="ft14 D1D1D1">{{
              discountData.thisMonthAccountAmount
            }}</span>
          </p>
        </div>
        <div class="mt20">
          <p>
            <span class="ft14 C787878 inline_block w120">本月使用金额:</span>
            <span class="ft14 D1D1D1">{{
              discountData.thisMonthHasUseAmount
            }}</span>
          </p>
          <p class="mt8">
            <span class="ft14 C787878 inline_block w120">本月期末剩余金额:</span>
            <span class="ft14 D1D1D1">{{
              discountData.notUseAmount
            }}</span>
          </p>
        </div>
        <div class="mt20">
          <p>
            <span class="ft14 C787878 inline_block w120">占用金额:</span>
            <span class="ft14 D1D1D1">{{
              discountData.occupyAmount
            }}</span>
          </p>
          <p class="mt8">
            <span class="ft14 C787878 inline_block w120">冻结金额:</span>
            <span class="ft14 D1D1D1">{{
              discountData.freezeAmount
            }}</span>
          </p>
        </div>
      </div>
    </el-card>
    <!-- 货补情况 -->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <p class="ft16">货补情况</p>
      </div>
      <!-- <div class="text item mybalance_content flex justify_content_around">
        <div>
          <p class="ft16 D1D1D1 mb20">可用资金余额</p>
          <p class="ft28 D1D1D1">{{ goodsData.usableAmount }}</p>
        </div>
        <div class="mt20">
          <p>
            <span class="ft14 C787878 inline_block w100">本月可用数量:</span>
            <span class="ft14 D1D1D1">{{
              goodsData.thisMonthUsableAmount
            }}</span>
          </p>
          <p class="mt8">
            <span class="ft14 C787878 inline_block w100">上月余额:</span>
            <span class="ft14 D1D1D1">{{
              goodsData.lastMonthUsableAmount
            }}</span>
          </p>
        </div>
        <div class="mt20">
          <p>
            <span class="ft14 C787878 inline_block w100">本月上账数量:</span>
            <span class="ft14 D1D1D1">{{
              goodsData.thisMonthAccountAmount
            }}</span>
          </p>
          <p class="mt8">
            <span class="ft14 C787878 inline_block w100">本月使用数量:</span>
            <span class="ft14 D1D1D1">{{
              goodsData.thisMonthHasUseAmount
            }}</span>
          </p>
        </div>
      </div> -->
      <div>
          <el-table
            ref="fundSituationId" 
            :data="goodsData"
            :header-cell-style="{textAlign: 'center',fontSize:'13px',color:'#787878',background:'#F5F5F5'}"
            :cell-style="{textAlign:'center',fontSize:'14px',color:'#1D1D1D',lineHeight:'24px'}">
            <el-table-column
                v-for="(item,index) in table_config.thead"
                :key="index"
                :prop="item.prop"
                :label="item.label">
            </el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
</template>
<script>
/**
 *   @Author : 李阳
 *   @Date : 2021/3/30
 *   @Version : 1.0.0
 *   @Last Modified by : 李阳
 *   @Last Modified time : 2021/3/30
 *   @desc 我的余额
 **/
import { gooddsDetail, discountDetail, getDealerBalance } from "@/api/api";
import { Storage } from "@/utils/storage";
import qs from 'qs';
export default {
  name: "mybalance",
  data() {
    return {
      /**
       * @description 折扣/货补参数接收对象
       * @param { String }   lastMonthUsableAmount  截至上月剩余可用余额
       * @param { String }   thisMonthAccountAmount 本月内上账费用总额
       * @param { String }   thisMonthHasUseAmount  本月内使用费用
       * @param { String }   thisMonthUsableAmount  截至本月剩余可用余额
       * @param { String }   usableAmount           剩余可使用金额
       */
      discountData: {},
      // 2.货补接受参数
      goodsData: [],
      // 3.资金情况
      getDealer: {},
      table_config:{
          thead:[
            {label:"可用货补产品",prop:"productName"},
            {label:"本月期末可用金额",prop:"usableAmount"},
            {label:"本月期初剩余金额",prop:"thisMonthInitNotUseAmount"},
            {label:"本月上账金额",prop:"thisMonthAccountAmount"},
            {label:"本月使用金额",prop:"thisMonthHasUseAmount"},
            {label:"本月期末剩余金额",prop:"notUseAmount"},
            {label:"占用金额",prop:"occupyAmount"},
            {label:"冻结金额",prop:"freezeAmount"},
          ],
      },
    };
  },
  methods: {
    /**
     * @description 获取用户编码/当前年月函数
     * @param  { String }   customerCode  用户编码
     * @param  { String }   yearMonth 当前年月
     * @return { Object }
     */
    getResInfo() {
      let customerCode = Storage.l.get("customerCode");
      let currentDate = new Date();
      let year = currentDate.getFullYear();
      let month = (currentDate.getMonth() + 1).toString().padStart(2, 0); //月份加一前补0
      let yearMonth = `${year}-${month}`;
      return {
        customerCode: customerCode,
        yearMonth: yearMonth,
      };
    },
    /**
     * @description 费用汇总查询接口函数
     * @function    discountDetail 折扣费用查询函数
     * @function    gooddsDetail   货补费用查询函数
     * @function    getDealerBalance  资金费用查询函数
     */
    getDFeeDetail(params) {
      discountDetail({customerCode: Storage.l.get("customerCode")}).then((res) => {
        this.discountData = res.result;
      });
      gooddsDetail({customerCode: Storage.l.get("customerCode")}).then((res) => {
        this.goodsData = res.result;
      });
      getDealerBalance({customerCode: Storage.l.get("customerCode")}).then((res) => {
        this.getDealer = res.result;
      });
    }
  },
  created() {
    // 接口请求
    this.getDFeeDetail(this.getResInfo());
  },
};
</script>
<style lang="scss" scoped>
.flex-info{
  justify-content: space-around;
}
.w120{
  width: 120px;
}
.mybalance {
  .box-card {
    margin-bottom: 20px;
    /deep/ .el-card__header {
      padding: 0px;
      border: 0px;
      .clearfix {
        background-color: $color-primary; //主题色淡化
        padding: 10px;
        P {
          color: #fff;
        }
      }
    }
    /deep/.el-table {
      th.gutter {
        display: table-cell !important;
      }
      colgroup.gutter {
        display: table-cell !important;
      }
    }
  }
}
</style>